import { render, staticRenderFns } from "./ClaimDocument.vue?vue&type=template&id=67efe9c2&"
import script from "./ClaimDocument.vue?vue&type=script&lang=js&"
export * from "./ClaimDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports